export default __webpack_public_path__ + "static/src/assets/images/icons/icon_refresh_gray.png";